import startContent from "./start-content.json";
import FloatingBackButton from "../components/FloatingBackButton";
import aboutContent from "./about-content.json";
import {Spacer} from "../components/Spacer";
import ParallaxPage from "../components/ParallaxPage";
import React from "react";
import {ParagraphsComponent} from "../components/ParagraphsComponent";

export const About = () => {
    return (
        <div>
            <FloatingBackButton/>
            <ParallaxPage
                imageUrl={startContent.about.imageUrl}
                content={
                    <div>
                        <h1>{aboutContent.title}</h1>
                        <h2>{aboutContent.subtitle}</h2>
                        <Spacer height={100}/>
                        <ParagraphsComponent paragraphs={aboutContent.paragraphs} />
                    </div>
                }
            />
        </div>
    );
};